import api from './api';

export const testService = {
    // Order a new test
    orderTest: async (data) => {
        try {
            const response = await api.post('/tests', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to order test');
        }
    },

    // Order several tests at once (a doctor usually requests a panel).
    // data: { patientId, visitId?, notes?, tests: [{ catalogId } | { testName, testType }] }
    orderTests: async (data) => {
        try {
            const response = await api.post('/tests/bulk', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to order tests');
        }
    },

    // Get the branch lab's catalog of offered tests (to populate the order form)
    getBranchCatalog: async () => {
        try {
            const response = await api.get('/tests/catalog');
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch test catalog');
        }
    },

    // The built-in investigation library, grouped by category. Drives the
    // settings screen where a doctor picks the tests their speciality uses.
    getLibrary: async () => {
        try {
            const response = await api.get('/tests/library');
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch the test library');
        }
    },

    // Get tests for a patient
    getPatientTests: async (patientId, filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/tests/patient/${patientId}?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch tests');
        }
    },

    // Update test result
    updateTestResult: async (testId, data) => {
        try {
            const response = await api.put(`/tests/${testId}/result`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to update test result');
        }
    },

    // Get single test
    getTest: async (testId) => {
        try {
            const response = await api.get(`/tests/${testId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch test');
        }
    },

    // Cancel test
    cancelTest: async (testId) => {
        try {
            const response = await api.delete(`/tests/${testId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to cancel test');
        }
    },

    // Upload attachment
    uploadAttachment: async (formData) => {
        try {
            const response = await api.post('/tests/attachments', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to upload attachment');
        }
    },

    // Get patient attachments
    getPatientAttachments: async (patientId, filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/tests/attachments/patient/${patientId}?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch attachments');
        }
    },

    // Get single attachment
    getAttachment: async (attachmentId) => {
        try {
            const response = await api.get(`/tests/attachments/${attachmentId}`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch attachment');
        }
    },

    // Delete attachment
    deleteAttachment: async (attachmentId) => {
        try {
            const response = await api.delete(`/tests/attachments/${attachmentId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to delete attachment');
        }
    }
};
